// src/pages/Test.jsx
import React from 'react';
import { useLogin } from './contexts/LoginContext';
import LoginModal from '../components/LoginModal';

const Test = () => {
  const { setShowLoginModal, isLoggedIn, user } = useLogin();

  return (
    <>
      <button onClick={() => setShowLoginModal(true)}>Login</button>

      <div>
        {isLoggedIn ? (
          <p>Welcome, {user?.name || 'User'}!</p>
        ) : (
          <p>Please log in.</p>
        )}
      </div>

      <LoginModal />
    </>
  );
};

export default Test;